export const isAscendingOrder = (order) => {
  if (!order) return false;
  if (typeof order === 'string') {
    const upper = order.trim().toUpperCase();
    return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
  }
  if (typeof order === 'object') {
    if (order.orderByValue !== undefined) {
      const upper = String(order.orderByValue).trim().toUpperCase();
      return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
    }
    if (order.order_by !== undefined) {
      const upper = String(order.order_by).trim().toUpperCase();
      return upper === 'ASC' || upper === 'A-Z' || upper === '1' || upper === 'TRUE';
    }
    if (order.isDecending !== undefined) {
      return order.isDecending === false || order.isDecending === 'false';
    }
    if (order.isDescending !== undefined) {
      return order.isDescending === false || order.isDescending === 'false';
    }
    if (order.isAscending !== undefined) {
      return order.isAscending === true || order.isAscending === 'true';
    }
  }
  return false;
};
